/** Espejo cliente del compilador (preview en vivo). El servidor recompila al guardar. */

function esc(s) {
  return String(s ?? '')
    .replace(/&/g, '&' + 'amp;')
    .replace(/</g, '&' + 'lt;')
    .replace(/>/g, '&' + 'gt;')
    .replace(/"/g, '&' + 'quot;');
}

function safeUrl(url) {
  const u = (url || '').trim();
  if (!u) return '#';
  if (u.includes('{{')) return u;
  const low = u.toLowerCase();
  if (low.startsWith('https://') || low.startsWith('http://') || low.startsWith('mailto:')) return u;
  return '#';
}

/** Render de un solo bloque → filas <tr> (para preview por bloque). */
export function renderBlock(b) {
  switch (b.type) {
    case 'logo': {
      const mh = b.maxHeight || 56;
      const align = b.align || 'center';
      const bg = b.bg || '#FFFFFF';
      const useCustom = b.source === 'custom' && b.src;
      const src = useCustom ? safeUrl(b.src) : '{{logo_url}}';
      const srcAttr = (src && src !== '#') ? esc(src) : '{{logo_url}}';
      return `<tr><td align="${esc(align)}" style="padding:28px 32px 12px;background:${esc(bg)};">
        <img src="${srcAttr}" alt="{{tenant_name}}" width="160"
          style="max-height:${mh}px;max-width:180px;height:auto;display:block;border:0;${align === 'center' ? 'margin:0 auto;' : ''}" />
      </td></tr>`;
    }
    case 'hero': {
      const bg = b.bg || '#0F172A';
      const accent = b.accentColor || '#F72585';
      return `<tr><td align="center" style="padding:24px 32px;background:${esc(bg)};">
        <p style="margin:0 0 8px;color:#F8FAFC;font-size:14px;">${b.greeting || ''}</p>
        <p style="margin:0;font-size:36px;line-height:1.08;font-weight:800;letter-spacing:-0.5px;">
          <span style="color:#F8FAFC;">${esc(b.title || '')}</span>
          ${b.titleAccent ? `<br><span style="color:${esc(accent)};">${esc(b.titleAccent)}</span>` : ''}
        </p></td></tr>`;
    }
    case 'text': {
      const color = b.color || '#334155';
      const size = b.size || 16;
      let html = b.html || b.text || '';
      if (html && !html.includes('<')) html = `<p style="margin:0;">${esc(html)}</p>`;
      return `<tr><td style="padding:8px 36px 20px;color:${esc(color)};font-size:${size}px;line-height:1.55;background:#FFFFFF;">${html}</td></tr>`;
    }
    case 'image': {
      const src = safeUrl(b.src);
      if (!src || src === '#') {
        return `<tr><td align="center" style="padding:12px 36px;background:#FFFFFF;color:#94A3B8;font-size:12px;">[Imagen: agrega una URL]</td></tr>`;
      }
      return `<tr><td align="center" style="padding:12px 36px;background:#FFFFFF;">
        <img src="${esc(src)}" alt="${esc(b.alt || '')}" width="${b.width || 520}"
          style="max-width:100%;height:auto;display:block;border:0;border-radius:8px;" />
      </td></tr>`;
    }
    case 'button': {
      const href = safeUrl(b.url || '{{enlace}}');
      const bg = b.bg || '#F72585';
      const color = b.color || '#FFFFFF';
      const radius = b.radius || 10;
      return `<tr><td align="center" style="padding:4px 36px 28px;background:#FFFFFF;">
        <a href="${href.includes('{{') ? href : esc(href)}" style="display:inline-block;background:${esc(bg)};color:${esc(color)};text-decoration:none;font-weight:700;font-size:15px;padding:14px 28px;border-radius:${radius}px;">${esc(b.label || 'Ver más')}</a>
      </td></tr>`;
    }
    case 'spacer': {
      const h = Math.max(4, Math.min(120, b.height || 16));
      return `<tr><td style="height:${h}px;line-height:${h}px;font-size:1px;background:#FFFFFF;">&nbsp;</td></tr>`;
    }
    case 'divider':
      return `<tr><td style="padding:8px 36px;background:#FFFFFF;"><div style="border-top:1px solid ${esc(b.color || '#E2E8F0')};font-size:1px;">&nbsp;</div></td></tr>`;
    case 'footer':
      return `<tr><td style="padding:20px 32px;background:#0F172A;color:#94A3B8;font-size:12px;line-height:1.5;text-align:center;">${b.text || 'Enviado por {{tenant_name}}.'}</td></tr>`;
    case 'video': {
      const url = (b.url || b.youtube_url || '').trim();
      const m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/))([A-Za-z0-9_-]{6,})/);
      const vid = m ? m[1] : null;
      if (!vid) {
        return `<tr><td align="center" style="padding:12px 36px;background:#FFFFFF;color:#94A3B8;font-size:12px;">[Video: pega un enlace de YouTube]</td></tr>`;
      }
      const thumb = `https://img.youtube.com/vi/${vid}/hqdefault.jpg`;
      const watch = `https://www.youtube.com/watch?v=${vid}`;
      const title = esc(b.title || 'Ver video');
      return `<tr><td align="center" style="padding:12px 36px;background:#FFFFFF;">
        <a href="${watch}" style="text-decoration:none;display:inline-block;">
          <img src="${thumb}" alt="${title}" width="520" style="max-width:100%;height:auto;display:block;border:0;border-radius:10px;" />
          <p style="margin:10px 0 0;font-size:14px;font-weight:700;color:#0F172A;text-align:center;">▶ ${title}</p>
        </a></td></tr>`;
    }
    case 'carousel': {
      const slides = Array.isArray(b.slides) ? b.slides : [];
      const clean = slides.map((s, i) => {
        if (typeof s === 'string') return { src: safeUrl(s), alt: `Imagen ${i + 1}`, link: '' };
        return { src: safeUrl(s?.src), alt: s?.alt || `Imagen ${i + 1}`, link: s?.link ? safeUrl(s.link) : '' };
      }).filter(s => s.src && s.src !== '#');
      if (!clean.length) {
        return `<tr><td align="center" style="padding:12px 36px;background:#FFFFFF;color:#94A3B8;font-size:12px;">[Carrusel: sube al menos una imagen]</td></tr>`;
      }
      // Horizontal en el correo: una fila de celdas (el editor usa flechas; email no tiene JS)
      const cellW = Math.max(120, Math.floor(520 / Math.min(clean.length, 3)));
      const cells = clean.map((s) => {
        let img = `<img src="${esc(s.src)}" alt="${esc(s.alt)}" width="${cellW}" style="max-width:100%;height:auto;display:block;border:0;border-radius:8px;" />`;
        if (s.link && s.link !== '#') {
          const href = s.link.includes('{{') ? s.link : esc(s.link);
          img = `<a href="${href}" style="text-decoration:none;">${img}</a>`;
        }
        return `<td align="center" valign="top" style="padding:4px;width:${cellW}px;">${img}</td>`;
      }).join('');
      return `<tr><td style="padding:12px 24px;background:#FFFFFF;">
        <table role="presentation" cellpadding="0" cellspacing="0" width="100%" style="width:100%;"><tr>${cells}</tr></table>
      </td></tr>`;
    }
    default:
      return '';
  }
}

export function compileDocument(doc) {
  const meta = doc?.meta || {};
  const width = meta.width || 600;
  const bg = meta.background || '#F1F5F9';
  const font = meta.fontFamily || 'system-ui,Segoe UI,Arial,sans-serif';
  const rows = (doc?.blocks || []).map(renderBlock).join('\n');
  return `<!DOCTYPE html><html lang="es"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width"></head>
<body style="margin:0;padding:0;background:${esc(bg)};font-family:${esc(font)};">
<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background:${esc(bg)};padding:24px 12px;"><tr><td align="center">
<table role="presentation" width="${width}" cellpadding="0" cellspacing="0" style="max-width:${width}px;width:100%;background:#FFFFFF;border-radius:12px;overflow:hidden;border:1px solid #E2E8F0;">
${rows}
</table></td></tr></table></body></html>`;
}

/** HTML de un bloque envuelto en tabla 600 (preview clickable). */
export function compileBlockPreview(block, meta = {}) {
  const width = meta.width || 600;
  const font = meta.fontFamily || 'system-ui,Segoe UI,Arial,sans-serif';
  return `<table role="presentation" width="${width}" cellpadding="0" cellspacing="0" style="width:100%;max-width:${width}px;font-family:${esc(font)};">${renderBlock(block)}</table>`;
}

export function applyPreviewVars(html, vars = {}) {
  let out = html;
  Object.entries(vars).forEach(([k, v]) => {
    out = out.split(`{{${k}}}`).join(v);
  });
  return out;
}

export function newBlockId() {
  return `b_${Math.random().toString(36).slice(2, 12)}`;
}

export function emptyBlock(type, accent = '#F72585') {
  const id = newBlockId();
  const map = {
    logo: { id, type: 'logo', source: 'branding', src: '', align: 'center', maxHeight: 56, bg: '#FFFFFF' },
    hero: {
      id, type: 'hero', bg: '#0F172A', greeting: 'Hola, {{nombre_cliente}}.',
      title: 'Título', titleAccent: 'destacado', accentColor: accent,
    },
    text: {
      id, type: 'text', html: '<p style="margin:0;">Escribe tu mensaje aquí.</p>',
      color: '#334155', size: 16,
    },
    image: { id, type: 'image', src: '', alt: 'Imagen', width: 520 },
    video: { id, type: 'video', url: '', title: 'Ver video' },
    carousel: { id, type: 'carousel', slides: [{ src: '', alt: 'Imagen 1', link: '' }] },
    button: {
      id, type: 'button', label: 'Llamado a la acción', url: '{{enlace}}',
      bg: accent, color: '#FFFFFF', radius: 10,
    },
    spacer: { id, type: 'spacer', height: 20 },
    divider: { id, type: 'divider', color: '#E2E8F0' },
    footer: {
      id, type: 'footer',
      text: 'Enviado por {{tenant_name}}. Baja respondiendo este correo.',
    },
  };
  return map[type] || map.text;
}

export function defaultDocument(accent = '#F72585') {
  return {
    version: 1,
    meta: {
      width: 600,
      background: '#F1F5F9',
      fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",
      accent,
      preset: 'default',
    },
    blocks: [
      emptyBlock('logo', accent),
      emptyBlock('hero', accent),
      emptyBlock('text', accent),
      emptyBlock('button', accent),
      emptyBlock('footer', accent),
    ],
  };
}

export const MERGE_TAGS = [
  'nombre_cliente', 'tenant_name', 'logo_url', 'enlace',
  'fecha_cita', 'business_name', 'contact_name', 'contact_email', 'current_date',
];

export const BLOCK_PALETTE = [
  { type: 'logo', label: 'Logo', hint: 'Logo del negocio al enviar' },
  { type: 'hero', label: 'Encabezado', hint: 'Título grande con color' },
  { type: 'text', label: 'Texto', hint: 'Párrafos y negritas' },
  { type: 'image', label: 'Imagen', hint: 'Sube o pega una foto' },
  { type: 'video', label: 'Video YouTube', hint: 'Miniatura + enlace al video' },
  { type: 'carousel', label: 'Carrusel', hint: 'Varias fotos del producto' },
  { type: 'button', label: 'Botón', hint: 'Llamado a la acción' },
  { type: 'spacer', label: 'Espacio', hint: 'Aire entre bloques' },
  { type: 'divider', label: 'Divisor', hint: 'Línea sutil' },
  { type: 'footer', label: 'Pie legal', hint: 'Marca y baja' },
];

/** Paleta multi-vertical — se vende sola en cualquier rubro. */
export const COLOR_PALETTE = {
  marca: [
    { hex: '#F72585', name: 'Cavernicol' },
    { hex: '#0F172A', name: 'Negro suave' },
    { hex: '#FFFFFF', name: 'Blanco' },
    { hex: '#F8FAFC', name: 'Nieve' },
  ],
  verticales: [
    { hex: '#0EA5E9', name: 'Inmobiliaria' },
    { hex: '#10B981', name: 'Salud' },
    { hex: '#F59E0B', name: 'Retail' },
    { hex: '#8B5CF6', name: 'Educación' },
    { hex: '#EC4899', name: 'Belleza' },
    { hex: '#6366F1', name: 'Servicios' },
    { hex: '#EF4444', name: 'Urgente' },
    { hex: '#14B8A6', name: 'Wellness' },
  ],
  neutros: [
    { hex: '#334155', name: 'Texto' },
    { hex: '#64748B', name: 'Secundario' },
    { hex: '#94A3B8', name: 'Muted' },
    { hex: '#E2E8F0', name: 'Borde' },
    { hex: '#F1F5F9', name: 'Fondo' },
    { hex: '#0B1020', name: 'Hero dark' },
    { hex: '#1A0A14', name: 'Wine' },
    { hex: '#0B1F33', name: 'Navy' },
  ],
};

export const ALL_PALETTE_COLORS = [
  ...COLOR_PALETTE.marca,
  ...COLOR_PALETTE.verticales,
  ...COLOR_PALETTE.neutros,
];
